<template>
  <div class="d-flex w-100">
    <d-button
      v-if="!loaded"
      theme="primary"
      class="ml-auto mr-auto"
      :disabled="historyLoadInProgress"
      @click.prevent="loadData()">
      <template v-if="!historyLoadInProgress">
        Wczytaj historię zmian
      </template>
      <template v-else>
        <div class="spinner-border spinner-border-sm" role="status"></div>
      </template>
    </d-button>

    <table
      v-if="loaded"
      class="table mt-0 mb-0 full-width">
      <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0" style="width: 200px;">Data zmiany</th>
          <th scope="col" class="border-0">Użytkownik</th>
          <th scope="col" class="border-0" style="width: 120px;"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) of reversedItems()"
          :key="'history-item-' + index">
          <td class="align-middle">
            {{ item.updated_at.split('T').map(item => item.split('.')[0]).join(' ') }}
          </td>
          <td class="align-middle">
            {{ item.user_name }}
          </td>
          <td class="align-middle">
            <d-button
              theme="primary"
              @click.prevent="seeState(item.id)">
              Zobacz
            </d-button>
          </td>
        </tr>
      </tbody>
    </table>

    <order-evidence-popup
      v-if="showEvidencePopup"
      :evidenceData="selectedHistoryItem" />
  </div>
</template>

<script>
import FormUtils from './../../../utils/FormUtils.js';
import OrderEvidencePopup from './OrderEvidencePopup.vue';
import Vue from 'vue';

export default {
  name: 'order-evidence',
  props: [
    'orderID'
  ],
  components: {
    'order-evidence-popup': OrderEvidencePopup
  },
  data () {
    return {
      items: [],
      loaded: false,
      loadError: false,
      historyLoadInProgress: false,
      selectedHistoryItem: null,
      showEvidencePopup: false
    };
  },
  mounted () {
    this.$bus.$on('close-order-evidence-popup', this.closeEvidencePopup);
  },
  methods: {
    reversedItems () {
      return JSON.parse(JSON.stringify(this.items)).reverse();
    },
    loadData () {
      this.historyLoadInProgress = true;

      FormUtils.loadAdditionalData(this, {
        endpoint: '/orders/histories/items?order_id=' + parseInt(this.orderID, 10),
        loadedKey: 'loaded',
        outputKey: 'items',
        errorKey: 'loadError',
        successAction: () => {
          this.historyLoadInProgress = false;
        },
        failAction: () => {
          this.historyLoadInProgress = false;
        }
      });
    },
    seeState (historyItemID) {
      let itemToDisplay = this.items.filter(item => item.id === historyItemID);
      this.selectedHistoryItem = JSON.parse(JSON.stringify(itemToDisplay[0]));

      Vue.nextTick(() => {
        this.showEvidencePopup = true;
      });
    },
    closeEvidencePopup () {
      this.showEvidencePopup = false;

      Vue.nextTick(() => {
        this.selectedHistoryItem = null;
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('close-order-evidence-popup', this.closeEvidencePopup);
  }
}
</script>
